export default {
  Search: {
    placeholder: 'Hledat',
  },
  Actions: {
    toggle: 'Možnosti',
  },
};
